require('./bootstrap');
require('./laravel');

$(document).ready(function () {

    // Validation
    $('#input_url').on('input', function () {
        let url = $(this)[0];
        if(url.validity.typeMismatch){
            url.setCustomValidity("Site Url should contain https:// or http://");
        } else {
            url.setCustomValidity("");
        }
    });

    // Bootstrap
    $('[data-toggle="popover"]').popover();

    $('.popover-dismiss').popover({
        trigger: 'focus'
    });

    // Fixes popover positioning when used inside a modal
    $('#get_key_modal').on('show.bs.modal', function(){
        $('[data-toggle="popover"]').popover('update');
    });

    $('#helpModal').on('show.bs.modal', function (e) {
        var self    = this;
        var $iframe = $(this).find('iframe');

        $(self).find('.spinner').show();

        $($iframe).attr('src', $(e.relatedTarget).data('href'))
            .removeClass('d-none');

        $($iframe).on('load', function(){
            $(self).find('.spinner').hide();
        });
    });

    $('#helpModal').on('hidden.bs.modal', function (e) {
        $(this).find('iframe').attr('src', 'about:blank');
        $(this).find('.spinner').show();
    });

    // Tooltip
    $('.bt-clipboard').tooltip({
        trigger: 'manual',
        delay: {"show": 500, "hide": 800},
        placement: 'bottom',
        container: 'body'
    });

    function setTooltip(trigger, message) {
        $(trigger)
            .tooltip('hide')
            .attr('data-original-title', message)
            .tooltip('show');
    }

    function hideTooltip(trigger) {
        setTimeout(function () {
            $(trigger).removeAttr('data-original-title').tooltip('hide');
        }, 1000);
    }

    // Clipboard
    if (typeof ClipboardJS === 'function'){
        let clipboard = new ClipboardJS('.bt-clipboard');

        clipboard.on('success', function (e) {
            let target = $(e.trigger).data('clipboard-target');
            setTooltip(target, 'Copied to Clipboard!');
            hideTooltip(target);
        });

        clipboard.on('error', function (e) {
            let target = $(e.trigger).data('clipboard-target');
            setTooltip(target, 'Failed!');
            hideTooltip(target);
        });
    }


    // Populate available Responsive Voices
    if ($('[name="responsive_voice"]').length) {
        $('[name="responsive_voice"]').each(function () {
            var voiceList = responsiveVoice.getVoices();
            for (var i = 0; voiceList.length > i; i++) {
                var $element = $('optgroup[label="Voices"]', this).length ? $('optgroup[label="Voices"]', this) : $(this);
                $element.append('<option value="' + voiceList[i].name + '">' + voiceList[i].name + '</option>')
            }
            var currentVoice = $(this).data('responsiveVoice');
            if (currentVoice.length) {
                $(this).val(currentVoice);
            }
        });
    }

    $('.button_test_message').on('click', function () {
        let $sourceTxt   = $('#' + $(this).data('target-text') );
        let $sourceVoice = $('select[name=responsive_voice]');
        let voice        = 'UK English Female';

        // Decide which voice to use
        if (/profile\./gi.test($sourceVoice.val())) {
            voice = $('option:selected', $sourceVoice).text().match(/\((.*)\)/)[1];
        } else if ($sourceVoice.val() !== '') {
            voice = $sourceVoice.val()
        }

        // See if target is normal text or a voice from the Voices selection
        if ($sourceTxt.length > 0) {
            if (/profile\./gi.test($sourceTxt.val())) {
                responsiveVoice.speak(voice, voice);
            } else {
                responsiveVoice.speak($sourceTxt.val(), voice);
            }

        }
    });

    $('#form_home_website').on('submit', function (event) {
        if($('input[name=email]', this).length == 0){
            return;
        }

        event.preventDefault();

        let originalTitle;
        let self = this;

        var disableButton = function (form) {
            $button = $(form).find('button[type=submit]');
            originalTitle = $button.html();
            $button.html('<i class="fa fa-cog fa-spin"></i> Please wait...');
            $button.attr('disabled', 'true');
        };

        var enableButton = function (form) {
            $button = $(form).find('button[type=submit]');
            $button.html(originalTitle);
            $button.removeAttr('disabled');
        };

        $('#replace_key_modal').on('hide.bs.modal', function (e) {
            enableButton(self);
        });

        $('#save_form').on('click', function (e) {
            e.preventDefault();
            $(this).html('<i class="fa fa-cog fa-spin"></i> Redirecting...');
            enableButton(self);
            self.submit();
        });


        $.ajax({
            url: app_url + '/users/xhr_show',
            type: 'post',
            data: {
                'email': $('input[name=email]', this).val()
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            dataType: 'json',
            statusCode: {
                400: function (xhr) {
                    enableButton(self);
                },
                404: function(xhr){
                    $('#replace_key_modal').modal('hide');
                    self.submit();
                }
            },
            beforeSend: function( xhr ) {
                disableButton(self);
            },
            success: function (data) {
                $('#replace_key_modal').modal('show');
                $('#replace_key_modal').on('hide.bs.modal', function (e) {
                    enableButton(self);
                });
            },
            error: function(){
                $('#replace_key_modal').modal('hide');
                enableButton(self);
            }
        });
    });

    function verifyWebsite(identifier, tracking) {

        let limit = 30, count = 0;
        tracking  = typeof tracking !== 'undefined' ? tracking : true;

        let verify = function(){
            $.ajax({
                url: app_url + '/websites/xhr_verified',
                type: 'post',
                data: {
                    'id': identifier,
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                dataType: 'json',
                statusCode: {
                    400: function (xhr) {
                        if(window.ga && tracking){
                            ga('send', 'event', {
                                eventCategory: 'RVAgentTrial',
                                eventAction: 'Verify invalid',
                                eventLabel: identifier,
                                nonInteraction: true
                            });
                        }
                        console.info("RV Verification: this website id is not valid.");
                    },
                    404: function (xhr) {
                        if (count < limit) {
                            count++;
                            setTimeout(verify, 2000);
                        } else {
                            if(window.ga && tracking){
                                ga('send', 'event', {
                                    eventCategory: 'RVAgentTrial',
                                    eventAction: 'Verify failed',
                                    eventLabel: identifier,
                                    nonInteraction: true
                                });
                            }
                            console.info("RV Verification: we tried to verify " + limit + " times, giving up.")
                        }
                    }
                },
                beforeSend: function (xhr) {
                },
                success: function (data) {
                    if(window.ga && tracking){
                        ga('send', 'event', {
                            eventCategory: 'RVAgentTrial',
                            eventAction: 'Verify success',
                            eventLabel: identifier,
                            nonInteraction: true
                        });
                    }
                    document.location.reload();
                },
                error: function () {
                }
            });
        };

        if(window.ga && tracking){
            ga('send', 'event', {
                eventCategory: 'RVAgentTrial',
                eventAction: 'Verify request',
                eventLabel: identifier,
                nonInteraction: true
            });
        }

        verify();
    }

    let openLocation = function (name, url, width, height, windowCt){
        windowCt = windowCt || window;
        width    = width    || windowCt.innerWidth / 2;
        height   = height   || windowCt.innerHeight / 2;
        name     = name     || 'websiteVerifyPopup';

        let parentX      = windowCt.screenLeft ? windowCt.screenLeft : windowCt.screenX
          , parentY      = windowCt.screenTop ? windowCt.screenTop : windowCt.screenY
          , positionLeft = parentX + windowCt.innerWidth / 2 - width / 2
          , positionTop  = parentY + windowCt.innerHeight / 2 - height / 2;

        return windowCt.open(url, name, "toolbar=no, location=no, directories=no, status=no, menubar=no, copyhistory=no, width=" + width + ", height=" + height + ", top=" + positionTop + ", left=" + positionLeft);
    };

    $(".website_verify").on('click', function(e){

        let identifier  = $(this).data('id')
          , windowOpen  = $(this).data('window') || false
          , url         = $(this).attr('href')
          , verifyAgain = $(this).hasClass('website_verify_again');

        verifyWebsite(identifier, !verifyAgain);

        if( windowOpen ){
            e.preventDefault();
            openLocation(null, url);
        }
    });

    function verifyUser(identifier) {

        let limit = 30, count = 0;

        let verify = function(){
            $.ajax({
                url: app_url + '/users/xhr_verified_user',
                type: 'post',
                data: {
                    'id': identifier,
                    'user_type': 1
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                dataType: 'json',
                statusCode: {
                    400: function (xhr) {
                        console.error("RV User Verification: parameters not valid.");
                    },
                    404: function (xhr) {
                        if (count < limit) {
                            count++;
                            setTimeout(verify, 2000);
                        } else {
                            console.info("RV User Verification: we tried to verify " + limit + " times, giving up.")
                        }
                    }
                },
                beforeSend: function (xhr) {},
                success: function (data) {
                    document.location.reload();
                },
                error: function () {
                }
            });
        };

        verify();
    }

    $(".btn-upgrade").on('click', function(e){
        let identifier  = $(this).data('uid');
        if(identifier){
            verifyUser(identifier);
        }

        return true;
    });

    $(".website_focus_url").on('click', function(e){
        $('#get_key_modal').modal('hide');
        $('html,body').animate({scrollTop: $('input[name="url"]').offset().top - 50},'slow', function(){
            $("input[name='url']").focus();
        });
    });


    window.checkExistingUser = function checkExistingUser(email){
        $.ajax({
            url: app_url + '/users/xhr_show',
            type: 'post',
            data: {
                'email': email
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            dataType: 'json',
            statusCode: {
                400: function (xhr) {
                },
                404: function(xhr){
                }
            },
            beforeSend: function( xhr ) {
            },
            success: function (data) {
                $('#replace_key_modal').modal('show');

                $('#save_form').on('click', function (e) {
                    $(this).html('<i class="fa fa-cog fa-spin"></i> Redirecting...').attr('href', app_url + '/login?email=' + email);
                    //window.location.href = app_url + '/login?email=' + email;
                });
            },
            error: function(){
                $('#replace_key_modal').modal('hide');
            }
        });
    };

    $('.toast').toast('show');
});
